import axios from "axios";
import {
    CREATE_PROMO_CODE_REQUEST,
    CREATE_PROMO_CODE_SUCCESS,
    CREATE_PROMO_CODE_FAILURE,
    VALIDATE_PROMO_CODE_REQUEST,
    VALIDATE_PROMO_CODE_SUCCESS,
    VALIDATE_PROMO_CODE_FAILURE,
    APPLY_PROMO_CODE_SUCCESS,
    APPLY_PROMO_CODE_FAILURE,
    APPLY_PROMO_CODE_REQUEST,
    GET_PROMO_CODES_FAILURE,
    GET_PROMO_CODES_REQUEST,
    GET_PROMO_CODES_SUCCESS,
    DELETE_PROMO_CODE_FAILURE,
    DELETE_PROMO_CODE_REQUEST,
    DELETE_PROMO_CODE_SUCCESS,
} from "./ActionType";
import api, { API_BASE_URL } from "../../../config/api";

export const createPromoCode = (promoData) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_PROMO_CODE_REQUEST });

        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const { data } = await api.post(`${API_BASE_URL}/api/promo-codes/create`, promoData, config);

        dispatch({
            type: CREATE_PROMO_CODE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: CREATE_PROMO_CODE_FAILURE,
            payload: error.response?.data.message || error.message,
        });
    }
};

export const validatePromoCode = (code) => async (dispatch) => {
    try {
        dispatch({ type: VALIDATE_PROMO_CODE_REQUEST });

        const { data } = await api.get(`${API_BASE_URL}/api/promo-codes/validate/${code}`);

        dispatch({
            type: VALIDATE_PROMO_CODE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: VALIDATE_PROMO_CODE_FAILURE,
            payload: error.response?.data.message || error.message,
        });
    }
};


export const applyPromoCode = (orderId, promoCode, jwt) => async (dispatch) => {
    try {
        dispatch({ type: APPLY_PROMO_CODE_REQUEST }); // Add request type for consistency

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwt}`,
            },
        };

        const { data } = await api.post(
            `${API_BASE_URL}/api/orders/${orderId}/apply-promo`,
            { promoCode },
            config
        );

        dispatch({
            type: APPLY_PROMO_CODE_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: APPLY_PROMO_CODE_FAILURE,
            payload: error.response?.data.message || error.message,
        });
        throw new Error("Invalid promo-code");
    }
};

export const getPromoCodes = () => async (dispatch) => {
    try {
        dispatch({ type: GET_PROMO_CODES_REQUEST });

        const { data } = await api.get(`${API_BASE_URL}/api/promo-codes`);

        dispatch({
            type: GET_PROMO_CODES_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_PROMO_CODES_FAILURE,
            payload: error.response?.data.message || error.message,
        });
    }
};

export const deletePromoCode = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_PROMO_CODE_REQUEST });

        const { data } = await api.delete(`${API_BASE_URL}/api/promo-codes/delete/${id}`);

        dispatch({
            type: DELETE_PROMO_CODE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: DELETE_PROMO_CODE_FAILURE,
            payload: error.response?.data.message || error.message,
        });
    }
};